import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";
//import FooterElement from "../../Components/footer/FooterElement";
import {
  Box,
  Stack,
  Autocomplete,
  Typography,
  MenuItem,
  TextField,
} from "@mui/material";

import Button from "@mui/material/Button";
import { toast } from "react-toastify";
import { createFilterOptions } from "@mui/material/Autocomplete";
import LocalstorageHelper from "../../LocalStorageHelper/LocalstorageHelper";
import { Redirect } from "react-router-dom";
import { purple } from "@mui/material/colors";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { styled } from "@mui/material/styles";
import { darken, lighten } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Task from "@mui/icons-material/Task";
toast.configure();

const DebitNote = () => {
  //GET THE TOKEN FROM HELPER CLASS

  const userToken = LocalstorageHelper.GetUserToken();

  const redirectToLoginPage = () => {
    if (!userToken) {
      return <Redirect exact to="/sparepartsLogin" />;
    }
  };

  //TIMEOUT WHEN JWT EXPIRES
  setTimeout(() => {
    window.location.reload(false);
  }, 1800000);

  // TEXT FIELD VALUE STATES

  //get debitnote nos
  const [loading, setLoading] = useState(false);
  const [serviceflag, setserviceflag] = useState(true);
  const [typeflag, settypeflag] = useState(1);
  const [debitnoteno, setdebitnoteno] = useState(null);
  const [debitnotenoopts, setdebitnoteopts] = useState([]);
  const [pdfStream, setPdfStream] = useState(null);
  const service = [
    {
      value: false,
      label: "Is Service",
    },
    {
      value: true,
      label: "Non Service",
    },
  ];
  const type = [
    {
      value: 1,
      label: "Normal Print",
    },
    {
      value: 2,
      label: "eInvoice",
    },
  ];
  const [selectedbills, setselectedbills] = useState([]);
  const columns = [
    {
      field: "partyname",
      headerClassName: "super-app-theme--header",
      cellClassName: "super-app-theme--cell",
      headerName: "Party's Name",
      width: 250,
      editable: false,
    },
    {
      field: "gstno",
      headerClassName: "super-app-theme--header",
      cellClassName: "super-app-theme--cell",
      headerName: "GST NO",
      width: 120,
      editable: false,
    },
    {
      field: "debitnotedate",
      headerClassName: "super-app-theme--header",
      cellClassName: "super-app-theme--cell",
      headerName: "Date",
      width: 80,
      editable: false,
      type: "date",
    },
    {
      field: "debitnoteno",
      headerClassName: "super-app-theme--header",
      cellClassName: "super-app-theme--cell",
      headerName: "DocNo.",
      width: 98,
      editable: false,
    },
    {
      field: "ackdate",
      headerClassName: "super-app-theme--header",
      cellClassName: "super-app-theme--cell",
      headerName: "Ack date",
      width: 80,
      editable: false,
      type: "date",
    },
    {
      field: "ackno",
      headerClassName: "super-app-theme--header",
      cellClassName: "super-app-theme--cell",
      headerName: "AckNo.",
      width: 120,
      editable: false,
    },

    {
      field: "actions",
      type: "actions",
      headerClassName: "super-app-theme--header",
      cellClassName: "super-app-theme--cell",
      headerName: "Generate e-Invoice",
      width: 150,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <Button
            onClick={(e) => handleEinvoice(e, id)}
            variant="contained"
            size="small"
            disabled={loading}
          >
            {/* {selectedbills.ackno === null ? "Generate" : "Download"} */}
            Generate
          </Button>,
        ];
      },
    },
  ];

  async function getdebitnotenos() {
    try {
      const res = await fetch("/reports/debitnote/alldocs", {
        method: "GET",
        headers: { sptoken: userToken },
      });
      const data = await res.json();
      setdebitnoteopts(data);
    } catch (error) {
      console.log(error.message);
    }
  }
  useEffect(() => {
    getdebitnotenos();
  }, []);
  async function geteInvoicedata() {
    try {
      const res = await fetch(`/einvoice/debitnote/data/${serviceflag}`, {
        method: "GET",
        headers: { sptoken: userToken },
      });
      const data = await res.json();
      setselectedbills(data);
    } catch (error) {
      console.log(error.message);
    }
  }
  useEffect(() => {
    geteInvoicedata();
  }, [serviceflag]);
  const handleReport = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(
        `/reports/spare/debitnote/${debitnoteno.debitnoteid}`,
        {
          method: "GET",
          headers: { sptoken: userToken },
        }
      );

      const pdfBlob = await response.blob();
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setPdfStream(pdfUrl);
    } catch (err) {
      console.error(err);
    }
  };
  const handleEinvoice = async (e, id) => {
    e.preventDefault();
    try {
      setLoading(true);
      const headers = {
        "Content-Type": "application/json",
        sptoken: userToken,
      };
      const report = await fetch(`/einvoice/drn/${id}`, {
        headers,
      });
      if (report.status === 400) {
        // Error case: Handle the error information from the server
        const errorData = await report.json();
        toast.error(errorData.errorMessage);
        setLoading(false);
      } else {
        // Success case: Generate PDF or handle as needed
        const pdfBlob = await report.blob();
        const pdfUrl = URL.createObjectURL(pdfBlob);
        setPdfStream(pdfUrl);
        setLoading(false);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const [checked, setChecked] = useState(false);
  const handleToggle = (event) => {
    setChecked(event.target.checked);
  };
  const date = new Date();
  const [todate, settodate] = useState(date);
  const [fromdate, setfromdate] = useState(null);
  const [dndetails, setdndetails] = useState([]);

  //fetch state data
  async function getfromdatedata() {
    try {
      const response = await fetch("/reports/fromdate", {
        method: "GET",
        headers: { sptoken: userToken },
      });
      const jsonData = await response.json();
      setfromdate(jsonData.fromdate);
    } catch (err) {
      console.error(err.message);
    }
  }
  useEffect(() => {
    getfromdatedata();
  }, []);

  const einvoicecolumns = [
    {
      field: "gstno",
      headerClassName: "super-app-theme--header",
      headerName: "Gst No",
      width: 130,
      editable: false,
      cellClassName: "custom-cell",
      headerClassName: "custom-header",
    },
    {
      field: "partyname",
      headerClassName: "super-app-theme--header",
      headerName: "Party's Name",
      width: 300,
      editable: false,
      cellClassName: "custom-cell",
      headerClassName: "custom-header",
    },
    {
      field: "billno",
      headerClassName: "super-app-theme--header",
      headerName: "Bill No.",
      width: 150,
      editable: false,
    },
    {
      field: "billdate",
      headerClassName: "super-app-theme--header",
      headerName: "Bill Date",
      width: 100,
      editable: false,
      type: "date",
      cellClassName: "custom-cell",
      headerClassName: "custom-header",
    },
    {
      field: "billamt",
      headerClassName: "super-app-theme--header",
      headerName: "Bill Amt",
      width: 100,
      editable: false,
      type: "date",
      // cellClassName: "custom-cell",
      // headerClassName: "custom-header",
    },
    {
      field: "ackno",
      headerClassName: "super-app-theme--header",
      headerName: "Ack No.",
      width: 120,
      editable: false,
      cellClassName: "custom-cell",
      headerClassName: "custom-header",
    },
    {
      field: "ackdate",
      headerClassName: "super-app-theme--header",
      headerName: "Ack Date",
      width: 100,
      editable: false,
      type: "date",
      cellClassName: "custom-cell",
      headerClassName: "custom-header",
    },
    {
      field: "irn",
      headerClassName: "super-app-theme--header",
      headerName: "IRN",
      width: 400,
      editable: false,
      cellClassName: "custom-cell4Irn",
      headerClassName: "custom-header",
    },
  ];

  //formatted excel
  const printexcel = async (e) => {
    e.preventDefault();
    if (fromdate === null) {
      return toast.error("Please Select The From Date!!");
    }
    try {
      const fromDateStr = fromdate;
      const toDateStr = todate.toISOString();
      //partyarray = parray.map((opt) => opt.subledgerid);
      const body = { fromdate: fromDateStr, todate: toDateStr };
      const data = await fetch("/debitnote/einvoice/download/excel", {
        method: "POST",
        headers: {
          sptoken: userToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      const blob = await data.blob();

      // Create a download link
      const downloadLink = document.createElement("a");
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = "DebitNote_eInvoice.xlsx";

      // Append the link to the body
      document.body.appendChild(downloadLink);

      // Trigger the click event to start the download
      downloadLink.click();

      // Remove the link from the body
      document.body.removeChild(downloadLink);
    } catch (error) {
      console.log(error.message);
    }
  };

  //for view
  const viewdata = async (e) => {
    e.preventDefault();
    if (fromdate === null) {
      return toast.error("Please Select The From Date!!");
    }
    try {
      const fromDateStr = fromdate;
      const toDateStr = todate.toISOString();
      const body = { fromdate: fromDateStr, todate: toDateStr };
      const res = await fetch("/debitnote/einvoice/data/view", {
        method: "POST",
        headers: {
          sptoken: userToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      setdndetails(data);
    } catch (error) {
      console.log(error.message);
    }
  };
  const handleDownload = async (option, reportName) => {
    try {
      // const fromDateStr = fromdate;
      // const toDateStr = todate.toISOString();
      const body = { fromdate, todate };
      const res = await fetch(`/debitnote/einvoice/data/download`, {
        method: "POST",
        headers: {
          sptoken: userToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      const blob = await res.blob(); // Convert response to a Blob
      const filename = `DEBITNOTE_INVOICE_REGISTER.pdf`; // Set the desired file name for the download
      // Create a download link
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;

      // Programmatically click the link to initiate download
      link.click();

      // Clean up resources
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.log(error.message);
    }
    console.log(`Downloading ${option} report: ${reportName}`);
  };
  return (
    <div>
      <Sidebar
        Title={"Debit Note Print"}
        expandedPanel={"panel3"}
        children={
          <Box
            component="form"
            sx={{
              width: "100%",
            }}
            //onSubmit={handleSubmit}
            autoComplete="off"
          >
            <Link to="/debitnote">
              <Button>←Go Back to Debit Note</Button>
            </Link>
            <Stack spacing={2} mt={1} justifyContent={"center"} direction="row">
              {" "}
              <FormControlLabel
                label="Toggle Report"
                control={<Checkbox checked={checked} onChange={handleToggle} />}
              />
            </Stack>
            {!checked && (
              <>
                <Stack spacing={2} mt={5} ml={10} mb={2} direction="row">
                  <TextField
                    id="type"
                    required
                    select
                    label="Type"
                    value={typeflag}
                    onChange={(e) => settypeflag(e.target.value)}
                    variant="outlined"
                    sx={{
                      width: 250,
                    }}
                    size="small"
                  >
                    {type.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                  {typeflag === 2 ? (
                    <>
                      <TextField
                        id="isService"
                        required
                        select
                        label="ServiceFlag"
                        value={serviceflag}
                        onChange={(e) => setserviceflag(e.target.value)}
                        variant="outlined"
                        sx={{
                          width: 250,
                        }}
                        size="small"
                      >
                        {service.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </>
                  ) : (
                    <></>
                  )}
                </Stack>
                {parseInt(typeflag) === 2 ? (
                  <>
                    <Stack
                      spacing={2}
                      mt={2}
                      mb={2}
                      direction="row"
                      justifyContent={"flex-start"}
                    >
                      <Box
                        sx={{
                          height: 600,
                          width: "100%",
                          marginLeft: 10,
                          display: "flex",
                        }}
                      >
                        <DataGrid
                          sx={{
                            width: "100%",
                            "& .super-app-theme--header": {
                              color: "#000",
                              fontSize: "14px", // Adjust font size here
                            },
                            "& .super-app-theme--cell": {
                              fontSize: 10, // Adjust font size for cell
                            },
                          }}
                          rows={selectedbills}
                          columns={columns}
                          loading={loading}
                          rowHeight={30}
                          headerHeight={30}
                          initialState={{
                            pagination: {
                              paginationModel: {
                                pageSize: 5,
                              },
                            },
                          }}
                          pageSizeOptions={[5]}
                          getRowId={(item) => item.debitnoteid}
                          // checkboxSelection
                          // onSelectionModelChange={(item) => setpartno(item)}
                        />
                      </Box>
                    </Stack>
                  </>
                ) : (
                  <>
                    <Stack
                      spacing={10}
                      columnGap={2}
                      direction="row"
                      mt={5}
                      mx={20}
                      mb={4}
                    >
                      <Autocomplete
                        id="debitnos"
                        value={debitnoteno}
                        // filterOptions={filterOptions}
                        onChange={(event, newValue) => {
                          setdebitnoteno(newValue);
                        }}
                        options={debitnotenoopts}
                        getOptionLabel={(option) => option.docdetails}
                        sx={{
                          width: "40% ",
                        }}
                        renderInput={(billopts) => (
                          <TextField
                            required
                            {...billopts}
                            placeholder="Debit Nos"
                          />
                        )}
                        size="small"
                      />
                      <Button
                        type="submit"
                        // disabled={importDisabled}
                        onClick={handleReport}
                        variant="contained"
                        component="label"
                        size="large"
                        sx={{ boxShadow: "2px 2px 6px  #404142", px: 5 }}
                        endIcon={<Task />}
                      >
                        Show Report
                      </Button>
                    </Stack>
                  </>
                )}
                <Box sx={{ backgroundColor: "white" }}>
                  {pdfStream && (
                    <iframe
                      src={pdfStream}
                      width="100%"
                      height="600px"
                      title="report"
                    ></iframe>
                  )}
                </Box>
              </>
            )}
            {checked && (
              <>
                <Stack
                  spacing={2}
                  mt={1}
                  justifyContent={"center"}
                  direction="row"
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="From Date"
                      inputFormat="DD/MM/YYYY"
                      value={fromdate}
                      onChange={(newValue) => {
                        setfromdate(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          {...params}
                          sx={{
                            width: "20%",
                          }}
                          size="small"
                        />
                      )}
                    />
                  </LocalizationProvider>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="To Date"
                      inputFormat="DD/MM/YYYY"
                      value={todate}
                      onChange={(newValue) => {
                        settodate(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          required
                          {...params}
                          sx={{
                            width: "20%",
                          }}
                          size="small"
                        />
                      )}
                    />
                  </LocalizationProvider>
                  <Button
                    onClick={printexcel}
                    size="small"
                    variant="contained"
                    color="success"
                    //endIcon={<PrintIcon />}
                  >
                    Excel
                  </Button>
                  <Button
                    onClick={viewdata}
                    size="small"
                    variant="contained"
                    color="primary"
                    //endIcon={<PrintIcon />}
                  >
                    View
                  </Button>
                  <Button
                    onClick={handleDownload}
                    size="small"
                    variant="contained"
                    color="primary"
                    //endIcon={<PrintIcon />}
                  >
                    Download Pdf
                  </Button>
                </Stack>
                <Stack
                  spacing={2}
                  mt={3}
                  justifyContent={"center"}
                  direction="row"
                >
                  <Box
                    sx={{
                      height: 600,
                      width: "100%",
                      marginLeft: 10,
                      display: "flex",
                    }}
                  >
                    <DataGrid
                      sx={{
                        width: "100%",
                        "& .super-app-theme--header": {
                          // backgroundColor: "#3bb9ff",
                          color: "#000",
                        },
                        // "& .custom-header": {
                        //   fontSize: 10, // Decrease font size for the custom header
                        // },
                        "& .custom-cell": {
                          fontSize: 11, // Decrease font size for the custom cell
                        },
                        "& .custom-cell4Irn": {
                          fontSize: 9, // Decrease font size for the custom cell
                        },
                      }}
                      rows={dndetails}
                      columns={einvoicecolumns}
                      //loading={loading}
                      rowHeight={40}
                      headerHeight={40}
                      initialState={{
                        pagination: {
                          paginationModel: {
                            pageSize: 5,
                          },
                        },
                      }}
                      pageSizeOptions={[5]}
                      getRowId={(item) => item.debitnoteid}
                      // checkboxSelection
                      // onSelectionModelChange={(item) => setpartno(item)}
                    />
                  </Box>
                </Stack>
              </>
            )}
          </Box>
        }
      />
      {/* <FooterElement /> */}
      {redirectToLoginPage()}
    </div>
  );
};

export default DebitNote;
